export default {
  en: {
    title: "Reviewer inbox",
    subtitle: "Decisions waiting for a person, the most urgent deadline first.",
    queues: "Queues",
    queue: { all: "Everything for me", approver: "Approvals", "finance-approver": "Payment approvals", reviewer: "Reviews", requester: "The person who asked", "named-approvers": "Addressed to me" },
    selected_zero: "None selected",
    selected_one: "One selected",
    selected_two: "Two selected",
    selected_few: "{{count}} selected",
    selected_many: "{{count}} selected",
    selected_other: "{{count}} selected",
    selectTask: "Select task {{id}}",
    empty: "No tasks are waiting for you.",
    unassigned: "Unassigned",
    back: "Back to inbox",
    cancel: "Cancel",
    reason: "Comment (optional)",
    reasonRequired: "Reason (required)",
    assigned: "Assigned to {{who}}",
    col: { sla: "Time left", task: "Task", case: "Case", queue: "Queue", agent: "Agent", priority: "Priority", assignee: "Assignee", status: "Status", detail: "Detail" },
    priority: { urgent: "Urgent", high: "High", normal: "Normal", low: "Low" },
    escalationLevel: "Escalation level {{n}}",
    claimed: "Task claimed",
    unclaimed: "Task released",
    bulk: {
      approve: "Approve selected",
      reject: "Reject selected",
      approveTitle: "Approve {{n}} tasks",
      rejectTitle: "Reject {{n}} tasks",
      note: "Each task is signed individually against its own intent digest; results are reported per task. Edits are not possible in bulk.",
      results: "Bulk decision results",
      summary: "{{ok}} of {{total}} decisions applied",
      signed: "Signed with {{key}}",
    },
    stage: { validation: "Invalid input", sign: "Signing failed", decision: "Signed but not applied" },
    diff: { field: "Field", proposed: "Proposed by agent", final: "To be approved", change: "Change", added: "Added", removed: "Removed", changed: "Changed", same: "Unchanged" },
    context: {
      title: "Run and case context",
      summary: "Summary",
      trail: "Trail",
      diff: "Intent diff",
      untrusted: "Untrusted content influenced this intent (tool output, retrieval or user input). Review the arguments carefully.",
      agent: "Agent",
      intent: "Tool intent",
      run: "Run",
      case: "Case",
      requestedBy: "Requested by",
      created: "Requested",
      runTrail: "Run trail (orchestrator)",
      caseTrail: "Case timeline",
      digest: "Intent digest (SHA-256)",
      reasons: "Why the rules ask for approval",
    },
    reasons: {
      amount_above_threshold: "Amount above the approval threshold",
      risk_tier_2_side_effect: "Side effect by a tier-2 agent",
      untrusted_influence: "Influenced by untrusted content",
      privileged_access: "Privileged access change",
    },
    decision: {
      title: "Decision",
      mode: "Decision type",
      approve: "Approve",
      edit: "Edit and approve",
      reject: "Reject",
      args: "Arguments (JSON, validated against the tool schema)",
      valid: "Arguments are valid",
      signNote: "Your decision is signed by the audit service with your approver key and bound to the intent digest before it is applied.",
      signedBy: "Signed with {{key}} and applied",
      retry: "Retry applying the signed decision",
      closed: "This task is closed ({{status}}).",
      notApprover: "Only members of the {{queue}} queue can decide this task.",
      notApproval: "This task is not an approval; work it from the case.",
      decidedBy: "Decided by {{who}}",
      submit: { approve: "Sign and approve", edit: "Sign and approve edits", reject: "Sign and reject" },
    },
    done: { approve: "Approved", edit: "Approved with edits", reject: "Rejected" },
    reassign: { title: "Assignment", to: "Reassign to", current: "Assigned to", claim: "Claim", unclaim: "Release" },
    input: {
      title: "The agent asks you",
      yourAnswer: "Your answer",
      placeholder: "Type your answer",
      yes: "Yes",
      no: "No",
      submit: "Send my answer",
      done: "Answer sent. The agent goes on with it.",
      failed: "The answer could not be sent: {{message}}",
      notAllowed: "Waiting for an answer from {{who}}.",
      requester: "the person who asked",
      openInbox: "Answer it in the inbox",
      forYou: "This question is for you: answer it here and the agent goes on.",
      purpose: "The agent asked a question and waits for the answer. Answer it here and the agent goes on.",
    },
  },
  ar: {
    title: "صندوق المراجعة",
    subtitle: "مهام تنتظر قرارًا بشريًا، الأكثر إلحاحًا أولًا.",
    queues: "قوائم الانتظار",
    queue: { all: "كل ما يخصني", approver: "الموافقات", "finance-approver": "موافقات الدفع", reviewer: "المراجعات", requester: "الشخص الذي طلب", "named-approvers": "موجّهة إليّ" },
    selected_zero: "لم يُحدد شيء",
    selected_one: "تم تحديد مهمة واحدة",
    selected_two: "تم تحديد مهمتين",
    selected_few: "تم تحديد {{count}} مهام",
    selected_many: "تم تحديد {{count}} مهمة",
    selected_other: "تم تحديد {{count}} مهمة",
    selectTask: "تحديد المهمة {{id}}",
    empty: "لا توجد مهام بانتظارك.",
    unassigned: "غير مُسندة",
    back: "العودة إلى الصندوق",
    cancel: "إلغاء",
    reason: "تعليق (اختياري)",
    reasonRequired: "السبب (مطلوب)",
    assigned: "أُسندت إلى {{who}}",
    col: { sla: "الوقت المتبقي", task: "المهمة", case: "الحالة", queue: "القائمة", agent: "الوكيل", priority: "الأولوية", assignee: "المسؤول", status: "الوضع", detail: "التفاصيل" },
    priority: { urgent: "عاجلة", high: "عالية", normal: "عادية", low: "منخفضة" },
    escalationLevel: "مستوى التصعيد {{n}}",
    claimed: "تم استلام المهمة",
    unclaimed: "تم تحرير المهمة",
    bulk: {
      approve: "اعتماد المحدد",
      reject: "رفض المحدد",
      approveTitle: "اعتماد {{n}} مهام",
      rejectTitle: "رفض {{n}} مهام",
      note: "تُوقَّع كل مهمة بشكل مستقل مقابل بصمة نيتها، وتُعرض النتائج لكل مهمة. لا يمكن التعديل في الإجراء الجماعي.",
      results: "نتائج القرار الجماعي",
      summary: "طُبِّق {{ok}} من {{total}} قرارات",
      signed: "وُقِّع بالمفتاح {{key}}",
    },
    stage: { validation: "إدخال غير صالح", sign: "فشل التوقيع", decision: "وُقِّع ولم يُطبَّق" },
    diff: { field: "الحقل", proposed: "مقترح الوكيل", final: "ما سيُعتمد", change: "التغيير", added: "مضاف", removed: "محذوف", changed: "معدل", same: "دون تغيير" },
    context: {
      title: "سياق التشغيل والحالة",
      summary: "الملخص",
      trail: "السجل",
      diff: "فرق النية",
      untrusted: "تأثرت هذه النية بمحتوى غير موثوق (مخرجات أداة أو استرجاع أو إدخال مستخدم). راجع المعاملات بعناية.",
      agent: "الوكيل",
      intent: "نية الأداة",
      run: "التشغيل",
      case: "الحالة",
      requestedBy: "طلبه",
      created: "وقت الطلب",
      runTrail: "مسار التشغيل (المنسق)",
      caseTrail: "الخط الزمني للحالة",
      digest: "بصمة النية (SHA-256)",
      reasons: "لماذا تطلب القواعد الموافقة",
    },
    reasons: {
      amount_above_threshold: "المبلغ يتجاوز حد الاعتماد",
      risk_tier_2_side_effect: "أثر جانبي من وكيل بالمستوى 2",
      untrusted_influence: "متأثر بمحتوى غير موثوق",
      privileged_access: "تغيير صلاحيات مميزة",
    },
    decision: {
      title: "القرار",
      mode: "نوع القرار",
      approve: "اعتماد",
      edit: "تعديل واعتماد",
      reject: "رفض",
      args: "المعاملات (JSON، يُتحقق منها وفق مخطط الأداة)",
      valid: "المعاملات صالحة",
      signNote: "توقِّع خدمة التدقيق قرارك بمفتاحك كمعتمِد وتربطه ببصمة النية قبل تطبيقه.",
      signedBy: "وُقِّع بالمفتاح {{key}} وطُبِّق",
      retry: "إعادة محاولة تطبيق القرار الموقَّع",
      closed: "هذه المهمة مغلقة ({{status}}).",
      notApprover: "يمكن فقط لأعضاء قائمة {{queue}} اتخاذ القرار في هذه المهمة.",
      notApproval: "هذه المهمة ليست اعتمادًا؛ اعمل عليها من الحالة.",
      decidedBy: "قرّرها {{who}}",
      submit: { approve: "توقيع واعتماد", edit: "توقيع واعتماد التعديلات", reject: "توقيع ورفض" },
    },
    done: { approve: "تم الاعتماد", edit: "تم الاعتماد مع التعديل", reject: "تم الرفض" },
    reassign: { title: "الإسناد", to: "إعادة الإسناد إلى", current: "مُسندة إلى", claim: "استلام", unclaim: "تحرير" },
    input: {
      title: "يسألك الوكيل",
      yourAnswer: "إجابتك",
      placeholder: "اكتب إجابتك",
      yes: "نعم",
      no: "لا",
      submit: "أرسل إجابتي",
      done: "أُرسلت الإجابة. يتابع الوكيل بها.",
      failed: "تعذّر إرسال الإجابة: {{message}}",
      notAllowed: "بانتظار إجابة من {{who}}.",
      requester: "الشخص الذي طلب",
      openInbox: "أجب عنه في صندوق المراجعة",
      forYou: "هذا السؤال موجّه إليك: أجب هنا ويتابع الوكيل.",
      purpose: "طرح الوكيل سؤالًا وينتظر الإجابة. أجب هنا ويتابع الوكيل.",
    },
  },
};
